var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeliWrong(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t\t.st0{fill:var(--ion-color-danger);}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "alert",
    transform: "translate(250 366.483)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1434",
    transform: "translate(0 29.517)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4621",
    className: "st0",
    d: "M-218.7-372.9l-11.3-18.9c-1.3-2.2-4.2-3-6.4-1.6c-0.7,0.4-1.2,1-1.6,1.6l-11.3,18.9 c-1.3,2.2-0.6,5.1,1.7,6.4c0.7,0.4,1.5,0.7,2.4,0.7h22.6c2.6,0,4.7-2.1,4.7-4.7C-218-371.4-218.2-372.2-218.7-372.9z M-234-388.4 c1,0,1.9,0.8,1.9,1.9v7.5c0,1-0.8,1.9-1.9,1.9s-1.9-0.8-1.9-1.9v-7.5l0,0C-235.9-387.5-235-388.4-234-388.4z M-234-369.6 c-1.6,0-2.8-1.3-2.8-2.8c0-1.6,1.3-2.8,2.8-2.8c1.6,0,2.8,1.3,2.8,2.8l0,0C-231.2-370.8-232.4-369.6-234-369.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliWrong);
export default __webpack_public_path__ + "static/media/Deli_Wrong.0471c89b8dae39e601f41e03dd462760.svg";
export { ForwardRef as ReactComponent };